import React from "react";
import { getDietaryCodeLabel, normalizeDietaryCodes } from "../presentation/dietary";
import dairyFree from "../../ActionButton/assests/no-milk.png";
import glutenFree from "../../ActionButton/assests/gluten-free.png";
import sugarFree from "../../ActionButton/assests/sugar-free.png";
import nutFree from "../../ActionButton/assests/peanut-free.png";
import organic from "../../ActionButton/assests/bio_480.png";
import vegetarian from "../../ActionButton/assests/leaf.png";
import vegan from "../../ActionButton/assests/vegan.png";
import gluten from "../../ActionButton/assests/gluten.png";
import nutsSesame from "../../ActionButton/assests/nuts_sesame.png";
import dairy from "../../ActionButton/assests/dairy.png";
import egg from "../../ActionButton/assests/egg.png";
import seafood from "../../ActionButton/assests/seafood_shellfish.png";
import chilli from "../../ActionButton/assests/chilli.png";
import soy from "../../ActionButton/assests/soy.svg";

export const dietaryIcons = { dairy_free: dairyFree, gluten_free: glutenFree, sugar_free: sugarFree, nut_free: nutFree,
  organic, vegetarian, vegan, gluten, nuts_sesame: nutsSesame, dairy, egg, seafood_shellfish: seafood, chilli, soy };

export default function DietaryIcons({ product, language }) {
  const codes = normalizeDietaryCodes([product.dietary_restriction_codes, product.dietary_restrictions]);
  if (!codes.length) return null;
  return <div className="sf-product-card__dietary">
    {codes.map((code) => {
      const label = getDietaryCodeLabel(code, language);
      return dietaryIcons[code] ? <img key={code} src={dietaryIcons[code]} alt={label} title={label} /> : <small key={code}>{label}</small>;
    })}
  </div>;
}
